<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{ 'BATCH_MAILING.RECEIPTS_TAB.SELECT_BATCH' | translate }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <label class="form-control search">
      <div class="position-relative">
        <input
          type="search"
          name="main_pages_search"
          class="pr-5"
          [formControl]="searchControl"
          [placeholder]="'SEARCH' | translate"
          spellcheck="false"
        />

        <button
          type="button"
          class="postfix icon-button"
          attr.aria-label="{{ 'SEARCH' | translate }}"
        >
          <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
        </button>
      </div>
    </label>
    @if (!isLoading) {
      @if (items?.data?.length) {
        @for (item of items?.data; track item) {
          <app-batch-item
            [item]="item"
            [compact]="true"
            (toggleSelect)="updateSelection()"
          ></app-batch-item>
        }
        <app-paginator
          [items]="items"
          (pageChange)="pageChanged($event)"
        ></app-paginator>
      } @else {
        <div class="item-placeholder text-center">
          <img src="./assets/img/misc/box.svg" alt="" class="eye-d-none" />
          <p class="text-secondary">
            {{ 'BATCH_MAILING.BATCHES_TAB.NO_BATCHES_FOUND' | translate }}
          </p>
        </div>
      }
    } @else {
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span
      >&nbsp;
      <span>{{ 'SENDING' | translate }}...</span>
    }
  </div>

  <div class="modal-footer modal-footer--right">
    <button
      type="button"
      class="button button--outlined"
      (click)="hide('cancel')"
    >
      {{ 'CANCEL' | translate }}
    </button>

    <button
      [class.disabled]="!this.selected.length || this.selected.length > 8"
      class="button button--filled button--shadow"
      type="button"
      placement="bottom"
      (click)="createReceipt()"
    >
      @if (!isLoading) {
        <span>{{
          'BATCH_MAILING.RECEIPTS_TAB.CREATE_RECEIPT_BTN' | translate
        }}</span>
      } @else {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span
        >&nbsp;
        <span>{{ 'SENDING' | translate }}...</span>
      }
    </button>
  </div>
</div>
